import Images from "../../utils/Images";

export default function HeroBanner({ slide }) {
  if (!slide) return null;

  // Map slide index to corresponding images
  const getImageForSlide = (slideId) => {
    const imageMap = {
      1: { mobile: Images.hero_mobile_one, web: Images.hero_img_web_one },
      2: { mobile: Images.hero_mobile_two, web: Images.hero_img_web_two },
      3: { mobile: Images.hero_mobile_three, web: Images.hero_img_web_three },
      4: { mobile: Images.hero_mobile_four, web: Images.hero_img_web_four },
      5: { mobile: Images.hero_mobile_five, web: Images.hero_img_web_five },
      };
      return imageMap[slideId] || imageMap[4];
  };

  const images = getImageForSlide(slide.id);

  return (
    <div className="relative w-full h-full max-w-full overflow-hidden">
      {/* Mobile Image */}
      <img 
        src={images.mobile} 
        alt={slide.title || "Travel Security"} 
        className="object-contain w-full h-full md:hidden" 
        loading="eager"
        decoding="async"
      />
      {/* Web Image */}
      <img 
        src={images.web} 
        alt={slide.title || "Travel Security"} 
        className="object-contain w-full h-full hidden md:block" 
        loading="eager"
        decoding="async"
      />
    </div>
  );
}


